import { combineEpics } from 'redux-observable';
import { of, fromPromise } from '../common/rxjs/observable';
import { tap, mergeMap, map, switchMap, startWith, catchError, ignoreElements } from '../common/rxjs/operators';
import { delay } from 'rxjs/operators/delay';
import RequestEpicDescriptor from './RequestEpicDescriptor';
import requestEntity from './requestEntity';
import { ProfileActionTypes, FetchProfile, UpdateProfile, UpdatePassword, ResetPassword, DeleteSelf, FetchProfileActionTypes, LOGOUT, LOGOUT_ALL_SESSIONS, DeleteSelfActionTypes, RemoveFromAccountActionTypes, RemoveFromAccount, logout as logoutAction } from '../actions/ProfileActions';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import ProfileAPI from '../api/ProfileAPI';
import { getFetchProfileRequestStatus, getUpdateProfileRequestStatus, getResetPasswordRequestStatus, getDeleteSelfRequestStatus, getRemoveFromAccountRequestStatus } from '../selectors/RequestStatusSelector';
import LoginEmailsActions from '../login-emails/actions';
import PasswordActions from '../password/actions';
import SendAsEmailsActions from '../send-as-emails/actions';
import { createAction } from '../common/actions';
import UsersAPI from '../api/UsersAPI';
import AppUsersAPI from '../api/AppUsersAPI';
import { tracker } from '../lib/tracker';
import { LOGOUT_API, LOGOUT_ALL_DEVICES_API } from '../constants/LoginUrls';
const fetchProfile = requestEntity(new RequestEpicDescriptor({
  apiFunction: ProfileAPI.getProfile,
  initiatingActionType: ProfileActionTypes.LOAD_PROFILE,
  requestActions: FetchProfile,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestStatusSelector: getFetchProfileRequestStatus
}));
const updateProfile = requestEntity(new RequestEpicDescriptor({
  apiFunction: ProfileAPI.updateProfile,
  initiatingActionType: ProfileActionTypes.UPDATE_PROFILE,
  requestActions: UpdateProfile,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestStatusSelector: getUpdateProfileRequestStatus,
  alertOnSuccess: true,
  alertOnFailure: true
}));
const updatePassword = action$ => action$.ofType(ProfileActionTypes.UPDATE_PASSWORD).pipe(switchMap(action => fromPromise(ProfileAPI.updatePassword(action.payload.data)).pipe(
// @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 0.
map(() => UpdatePassword.success()), catchError(err => {
  return err.status === 400 ?
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
  of(UpdatePassword.success(err)) :
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
  of(UpdatePassword.failure(err));
}),
// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
startWith(UpdatePassword.request()))));
const resetPassword = requestEntity(new RequestEpicDescriptor({
  apiFunction: ProfileAPI.resetPassword,
  initiatingActionType: ProfileActionTypes.RESET_PASSWORD,
  requestActions: ResetPassword,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestStatusSelector: getResetPasswordRequestStatus
}));
const loginEmailsGlue = action$ => action$.ofType(FetchProfileActionTypes.SUCCESS).pipe(mergeMap(action => of(createAction(LoginEmailsActions.LOAD_SUCCESS, action.payload.data.loginEmails))));
const passwordGlue = action$ => action$.ofType(FetchProfileActionTypes.SUCCESS).pipe(mergeMap(action => of(createAction(PasswordActions.LOAD_SUCCESS, action.payload.data.passwordUpdatedAt))));
const sendAsEmailsGlue = action$ => action$.ofType(FetchProfileActionTypes.SUCCESS).pipe(mergeMap(action => {
  let payload = null;
  // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
  if (action.payload.data.canSendAsEmails) {
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    payload = action.payload.data.sendAsEmails;
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'LOAD_SUCCESS' does not exist on type '{}... Remove this comment to see the full error message
  return of(createAction(SendAsEmailsActions.LOAD_SUCCESS, payload));
}));
const deleteSelf = requestEntity(new RequestEpicDescriptor({
  apiFunction: UsersAPI.deleteSelf,
  initiatingActionType: ProfileActionTypes.DELETE_SELF,
  requestActions: DeleteSelf,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestStatusSelector: getDeleteSelfRequestStatus
}));
const postDelete = action$ => action$.ofType(DeleteSelfActionTypes.SUCCESS).pipe(tap(() => tracker.track('usage', {
  action: 'gdprDelete'
})), delay(3000), map(() => logoutAction()));
const removeSelfFromAccount = requestEntity(new RequestEpicDescriptor({
  apiFunction: AppUsersAPI.removeFromAccount,
  initiatingActionType: ProfileActionTypes.REMOVE_FROM_ACCOUNT,
  requestActions: RemoveFromAccount,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestStatusSelector: getRemoveFromAccountRequestStatus
}));
const postRemove = action$ => action$.ofType(RemoveFromAccountActionTypes.SUCCESS).pipe(tap(() => tracker.track('usage', {
  action: 'removeFromAccount'
})), delay(3000), map(() => logoutAction()));
const logout = action$ => action$.ofType(LOGOUT).pipe(
// @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
tap(() => window.location = LOGOUT_API), ignoreElements());
const logoutAllSessions = action$ => action$.ofType(LOGOUT_ALL_SESSIONS).pipe(
// @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
tap(() => window.location = LOGOUT_ALL_DEVICES_API), ignoreElements());
export default combineEpics(fetchProfile, updateProfile, updatePassword, resetPassword, loginEmailsGlue, passwordGlue, sendAsEmailsGlue, deleteSelf, postDelete, removeSelfFromAccount, postRemove, logout, logoutAllSessions);